import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

import { getGradientByTimeSlot } from "./getGradientByTimeSlot";
import { getTimeSlotLabel } from "./getTimeSlotLabel";
import { type TimeSlot } from "./Open/types";
import { iconTypeByTimeSlotFilled } from "./TimeSlotIcon";

interface TimeSlotPillProps {
  timeSlot: TimeSlot;
  /**
   * If true, the pill will be compact and only show the icon
   */
  compact?: boolean;
  size?: PillSize;
  variant?: PillVariant;
}

export function TimeSlotPill(props: TimeSlotPillProps) {
  const { timeSlot, compact = false, size = "small", variant = "filled" } = props;

  const iconType = iconTypeByTimeSlotFilled[timeSlot];

  return (
    <Pill
      size={size}
      variant={variant}
      label={compact ? undefined : getTimeSlotLabel(timeSlot)}
      iconType={iconType}
      color={(theme) => theme.palette.text.primary}
      iconColor={(theme) => theme.palette.text.primary}
      sx={{
        width: "fit-content",
        background: (theme) => getGradientByTimeSlot({ timeSlot, theme }),
      }}
    />
  );
}
